import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { getDantesContent } from "@/content/dantes";

export default function DantesShell({ section = "overview", children }) {
  const { lang, toggle } = useLang();
  const copy = getDantesContent(lang);

  const links = [
    { key: "overview", href: "/dantes", label: copy.nav.overview },
    { key: "pricing", href: "/dantes/pricing", label: copy.nav.pricing },
    { key: "security", href: "/dantes/security", label: copy.nav.security },
  ];

  return (
    <div className="min-h-screen bg-[#090909] text-[var(--text-primary)]">
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(158,138,90,0.14),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.08),transparent_28%)]" />
        <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)", backgroundSize: "120px 120px" }} />
      </div>

      <header className="sticky top-0 z-40 border-b border-[var(--rule)] bg-[#090909]/90 backdrop-blur">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between px-6 py-4 md:px-10">
          <div className="flex items-center gap-6">
            <Link to="/" className="font-serif text-[12px] uppercase tracking-[0.28em] text-[var(--text-primary)]">
              {copy.nav.back}
            </Link>
            <span className="hidden h-4 w-px bg-[var(--rule)] md:block" />
            <span className="hidden font-sans text-[11px] uppercase tracking-[0.2em] text-[var(--gold)] md:block">
              Dantes
            </span>
          </div>

          <div className="flex items-center gap-5">
            <nav className="hidden items-center gap-5 md:flex">
              {links.map((link) => (
                <Link
                  key={link.key}
                  to={link.href}
                  className={`font-sans text-[11px] uppercase tracking-[0.16em] transition-colors ${
                    section === link.key ? "text-[var(--text-primary)]" : "text-[var(--text-tertiary)] hover:text-[var(--text-primary)]"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
            <button
              onClick={toggle}
              className="font-sans text-[11px] uppercase tracking-[0.16em] text-[var(--text-tertiary)] hover:text-[var(--text-primary)]"
            >
              {lang === "en" ? "FR" : "EN"}
            </button>
            <a
              href={process.env.REACT_APP_DANTES_APP_URL || "/login"}
              className="border border-[rgba(158,138,90,0.5)] px-3 py-2 font-sans text-[11px] uppercase tracking-[0.16em] text-[var(--gold)] transition-colors hover:border-[var(--gold)] hover:text-[var(--text-primary)]"
            >
              {copy.nav.app}
            </a>
          </div>
        </div>
      </header>

      <main className="relative z-10">{children}</main>
    </div>
  );
}
